"use client";

import React from "react";

type UIImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  removeWrapper?: boolean;
};

export const Image = React.forwardRef<HTMLImageElement, UIImageProps>(
  ({ removeWrapper: _removeWrapper, ...props }, ref) => {
    return <img ref={ref} alt={props.alt ?? ""} {...props} />;
  },
);

Image.displayName = "Image";
